import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, withCtx as _withCtx, normalizeClass as _normalizeClass, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-230f4d6a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky top-0 w-full bg-white z-999999" }
const _hoisted_2 = {
  class: "g-collapse",
  ref: "searchBarRef",
  style: {"box-shadow":"0px 0px 16px #eeeeee"}
}
const _hoisted_3 = { class: "g-container flex flex-col pt-[30px]" }
const _hoisted_4 = { class: "flex justify-between" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "logo-w" }, null, -1))
const _hoisted_6 = { class: "mr-[35px]" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-sm text-gary-text-color font-medium" }, "商品", -1))
const _hoisted_9 = { class: "mb-[40px]" }
const _hoisted_10 = { class: "flex flex-wrap justify-start space-b gap-[10px] sm:gap-[25px] mt-5" }
const _hoisted_11 = {
  key: 0,
  class: "g-container center flex",
  ref: "header"
}
const _hoisted_12 = ["onMouseenter", "onClick"]
const _hoisted_13 = { class: "header__right-menu h-[50px]" }
const _hoisted_14 = {
  key: 0,
  class: "flex flex-col ml-[-60px] text-sm gap-2.5 bg-white w-[140px] cursor-pointer drop-shadow-md"
}
const _hoisted_15 = { class: "flex flex-col gap-2 pt-[24px] pl-[30px]" }
const _hoisted_16 = { class: "pl-[30px] pb-[10px]" }
const _hoisted_17 = { class: "cartQuantity text-xs text-white bg-primary-color cursor-pointer" }
const _hoisted_18 = {
  key: 0,
  class: "flex flex-col ml-[-300px] mt-[15px] text-sm bg-white w-[340px] drop-shadow-md"
}
const _hoisted_19 = {
  key: 0,
  class: "h-[180px] pt-[70px] item-center text-center"
}
const _hoisted_20 = { key: 1 }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-[12px] ml-[16px] text-sm text-gary-text-color" }, " 我的禮物清單 ", -1))
const _hoisted_22 = { class: "overflow-scroll max-h-[486px]" }
const _hoisted_23 = { class: "flex flex-col pl-[18px] py-2" }
const _hoisted_24 = { class: "flex mt-2" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { class: "grow flex flex-col ml-2.5" }
const _hoisted_27 = { class: "flex" }
const _hoisted_28 = ["onClick"]
const _hoisted_29 = { class: "truncate w-[136px] text-sm tracking-[.06em] text-gary-text-color" }
const _hoisted_30 = { class: "text-[11px] text-light-gary-text-color" }
const _hoisted_31 = { class: "flex-1 mr-[30px]" }
const _hoisted_32 = { class: "text-[13px] leading-10 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_33 = { class: "h-[60px] flex justify-between items-center" }
const _hoisted_34 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end" }
const _hoisted_35 = {
  key: 1,
  class: "flex justify-between"
}
const _hoisted_36 = { class: "w-full" }
const _hoisted_37 = { class: "grow flex flex-col" }
const _hoisted_38 = { class: "flex" }
const _hoisted_39 = { class: "flex items-center mb-1.5 text-gary-text-color" }
const _hoisted_40 = { class: "truncate w-[118px] text-sm items-center text-center text-gary-text-color" }
const _hoisted_41 = { class: "grow h-[30px] flex items-center" }
const _hoisted_42 = { class: "grow mr-[30px]" }
const _hoisted_43 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_44 = { class: "flex mb-[10px]" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "hidden w-[80px] text-xs text-light-gary-text-color tracking-[0.1em]" }, " Bill & Jenny Love Day ", -1))
const _hoisted_46 = {
  key: 1,
  class: "bg-zinc-50 py-[10px] pl-[18px]"
}
const _hoisted_47 = { class: "w-[60px]" }
const _hoisted_48 = { class: "grow flex flex-col pl-[14px]" }
const _hoisted_49 = { class: "flex" }
const _hoisted_50 = { class: "flex items-center w-[136px] mb-1.5 font-medium text-gary-text-color" }
const _hoisted_51 = { class: "w-[20px] mr-1.5" }
const _hoisted_52 = { class: "truncate h-[22px] text-sm items-center text-center text-gary-text-color" }
const _hoisted_53 = { class: "grow h-[60px] flex items-center" }
const _hoisted_54 = { class: "grow mr-[30px]" }
const _hoisted_55 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_56 = { class: "h-[60px] flex justify-between items-center" }
const _hoisted_57 = { class: "flex w-[22%] gap-1.5 mr-[30px] justify-end" }
const _hoisted_58 = {
  key: 2,
  class: "hidden bg-zinc-50 pb-[10px] pl-[18px]"
}
const _hoisted_59 = { class: "w-[60px]" }
const _hoisted_60 = { class: "grow flex flex-col pl-[14px]" }
const _hoisted_61 = { class: "flex" }
const _hoisted_62 = { class: "flex items-center w-[136px] mb-1.5 font-medium text-gary-text-color" }
const _hoisted_63 = { class: "w-[20px] mr-1.5" }
const _hoisted_64 = { class: "truncate h-[22px] text-sm items-center text-center text-gary-text-color" }
const _hoisted_65 = { class: "grow h-[60px] flex items-center" }
const _hoisted_66 = { class: "grow mr-[30px]" }
const _hoisted_67 = { class: "text-[13px] leading-9 items-center text-gary-text-color tracking-[.06em] text-right" }
const _hoisted_68 = { class: "h-[30px] flex justify-between items-center" }
const _hoisted_69 = { class: "w-[100px] h-[30px] font-medium text-center leading-[30px]" }
const _hoisted_70 = { class: "flex justify-between h-[70px] pt-[13px] px-[20px]" }
const _hoisted_71 = { class: "flex flex-col" }
const _hoisted_72 = { class: "text-[13px] text-breadcrumb-color" }
const _hoisted_73 = /*#__PURE__*/_createTextVNode(" 共 ")
const _hoisted_74 = /*#__PURE__*/_createTextVNode(" 個商品 ")
const _hoisted_75 = { class: "text-black-900-color" }
const _hoisted_76 = /*#__PURE__*/_createTextVNode(" 總額 ")
const _hoisted_77 = { class: "pl-3" }
const _hoisted_78 = /*#__PURE__*/_createTextVNode(" NT. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icon = _resolveComponent("Icon")!
  const _component_SearchInput = _resolveComponent("SearchInput")!
  const _component_ProductItem = _resolveComponent("ProductItem")!
  const _component_Collapse = _resolveComponent("Collapse")!
  const _component_Spacer = _resolveComponent("Spacer")!
  const _component_divider = _resolveComponent("divider")!
  const _component_SquareItemFullImage = _resolveComponent("SquareItemFullImage")!
  const _component_InputWithButton = _resolveComponent("InputWithButton")!
  const _component_FavoriteButton = _resolveComponent("FavoriteButton")!
  const _component_UnderLine = _resolveComponent("UnderLine")!
  const _component_Btn = _resolveComponent("Btn")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_ModalConfirm = _resolveComponent("ModalConfirm")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createVNode(_component_Collapse, null, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _hoisted_5,
              _createElementVNode("div", {
                class: "close z-[2] cursor-pointer",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.productStore.setShowRectangleItem(false)))
              }),
              _createVNode(_component_Icon, {
                class: "cursor-pointer",
                iconName: "close_black",
                width: "24px",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.store.setShowSearchBar(false)))
              })
            ]),
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_SearchInput, {
                class: "mt-[12px] mb-[54px]",
                placeholder: '請輸入關鍵字',
                getInput: _ctx.getInput,
                "onUpdate:getInput": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.getInput) = $event))
              }, null, 8, ["getInput"])
            ]),
            (_ctx.searchCmdyList)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  _hoisted_8,
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchCmdyList, (cmdy, index) => {
                        return (_openBlock(), _createBlock(_component_ProductItem, {
                          key: index,
                          style: _normalizeStyle({ 'flex-basis': `calc(100%/5 - 20px)` }),
                          class: "sm:block cursor-pointer",
                          product: _ctx.searchCmdyList[index],
                          "onUpdate:product": ($event: any) => ((_ctx.searchCmdyList[index]) = $event),
                          onClick: ($event: any) => (_ctx.goProductDetail(_ctx.searchCmdyList[index]))
                        }, null, 8, ["style", "product", "onUpdate:product", "onClick"]))
                      }), 128))
                    ])
                  ]),
                  _createElementVNode("div", {
                    class: "cursor-pointer flex mb-[40px] text-sm underline decoration-gary-text-sub-title-color underline-offset-2 items-center text-gary-text-sub-title-color font-bold",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goToPage('search')))
                  }, [
                    _createTextVNode(" 查看全部" + _toDisplayString(_ctx.CmdyListLength) + "個商品 ", 1),
                    _createVNode(_component_Icon, {
                      iconName: "arrow_right_424242",
                      width: '24px'
                    })
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ], 512), [
          [_vShow, _ctx.store.state.showSearchBar]
        ])
      ]),
      _: 1
    }),
    (!_ctx.store.state.showSearchBar)
      ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
          _createElementVNode("div", {
            class: _normalizeClass([
          'logo',
          { 'logo-hide': _ctx.route.name === 'home' && !_ctx.store.state.showLogo }
        ]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.goToPage('home')))
          }, null, 2),
          _createElementVNode("ul", {
            class: "header__left-menu",
            onMouseleave: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args)))
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menuList, (menuItem) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: menuItem.MenuId
              }, [
                (_ctx.excludeMenu(_ctx.unescapeHTML(menuItem.Name)) || menuItem.ChildMenus.length > 0)
                  ? (_openBlock(), _createElementBlock("li", {
                      key: 0,
                      onMouseenter: ($event: any) => (_ctx.mouseenter(menuItem.ChildMenus)),
                      onClick: ($event: any) => (_ctx.goToPage(menuItem.TargetPageType))
                    }, _toDisplayString(_ctx.unescapeHTML(menuItem.Name)), 41, _hoisted_12))
                  : _createCommentVNode("", true)
              ], 64))
            }), 128))
          ], 32),
          _createVNode(_component_Spacer),
          _createElementVNode("ul", _hoisted_13, [
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                title: '搜尋',
                class: "cursor-pointer",
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.clickSearch()))
              }, [
                _createVNode(_component_Icon, { iconName: "search" })
              ])
            ]),
            _createElementVNode("li", null, [
              _createElementVNode("span", {
                title: '願望清單',
                class: "cursor-pointer",
                onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.goToPage('collection')))
              }, [
                _createVNode(_component_Icon, { iconName: "heart" })
              ])
            ]),
            _createElementVNode("li", {
              onMouseenter: _cache[14] || (_cache[14] = _withModifiers(($event: any) => (_ctx.store.setShowProfile(true)), ["stop"])),
              onMouseleave: _cache[15] || (_cache[15] = _withModifiers(($event: any) => (_ctx.store.setShowProfile(false)), ["stop"])),
              onTouchstart: _cache[16] || (_cache[16] = _withModifiers(($event: any) => (_ctx.store.setShowProfile(true)), ["stop"]))
            }, [
              _createVNode(_component_Icon, {
                class: "cursor-pointer",
                iconName: "profile"
              }),
              (_ctx.store.state.showProfile)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _createElementVNode("span", {
                        onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.goToPage('orderList')))
                      }, "訂單記錄"),
                      _createElementVNode("span", {
                        onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.goToPage('setting')))
                      }, "帳號設定"),
                      _createElementVNode("span", {
                        onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.goToPage('portfolio')))
                      }, "作品庫"),
                      _createElementVNode("span", {
                        onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.goToPage('contact')))
                      }, "聯絡客服")
                    ]),
                    _createVNode(_component_divider),
                    _createElementVNode("div", _hoisted_16, [
                      (_ctx.store.state.isLogin)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 0,
                            onClick: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
                          }, "登出"))
                        : _createCommentVNode("", true),
                      (!_ctx.store.state.isLogin)
                        ? (_openBlock(), _createElementBlock("span", {
                            key: 1,
                            onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.showLogin()))
                          }, "登入"))
                        : _createCommentVNode("", true)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ], 32),
            _createElementVNode("li", {
              onMouseenter: _cache[18] || (_cache[18] = _withModifiers(($event: any) => (_ctx.mouseenterForShoppingCart([])), ["stop"])),
              onMouseleave: _cache[19] || (_cache[19] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.mouseLeaveForShoppingCart && _ctx.mouseLeaveForShoppingCart(...args)), ["stop"])),
              onTouchstart: _cache[20] || (_cache[20] = _withModifiers(($event: any) => (_ctx.mouseenterForShoppingCart([])), ["stop"])),
              class: "relative"
            }, [
              _createVNode(_component_Icon, {
                class: "cursor-pointer",
                iconName: "bag"
              }),
              _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.orderShoppingCartCmdyListRef.length || 0), 1),
              (_ctx.store.state.showShoppingCart && _ctx.route.name !== 'shoppingCart')
                ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                    (_ctx.orderShoppingCartCmdyListRef.length === 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_19, " 購物車內目前沒有商品 "))
                      : _createCommentVNode("", true),
                    (_ctx.orderShoppingCartCmdyListRef.length !== 0)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                          _hoisted_21,
                          _createElementVNode("div", _hoisted_22, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.orderShoppingCartCmdyListRef, (shoppingCartItem, shoppingCartItemIndex) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: shoppingCartItem.OrderShoppingCartId,
                                class: ""
                              }, [
                                (shoppingCartItemIndex !== 0)
                                  ? (_openBlock(), _createBlock(_component_divider, { key: 0 }))
                                  : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_23, [
                                  _createElementVNode("div", _hoisted_24, [
                                    _createElementVNode("div", {
                                      class: "w-[60px]",
                                      onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem))
                                    }, [
                                      _createVNode(_component_SquareItemFullImage, {
                                        width: '60px',
                                        image: 
                            shoppingCartItem.CmdyImage?.PcWeb ||
                            shoppingCartItem.CmdyImageList?.slice(0, 1)[0].Image
                              .PcWeb ||
                            ''
                          
                                      }, null, 8, ["image"])
                                    ], 8, _hoisted_25),
                                    _createElementVNode("div", _hoisted_26, [
                                      _createElementVNode("div", _hoisted_27, [
                                        _createElementVNode("div", {
                                          onClick: ($event: any) => (_ctx.goProductDetail(shoppingCartItem)),
                                          class: "flex flex-col cursor-pointer"
                                        }, [
                                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.unescapeHTML(
                                  shoppingCartItem.Name ||
                                    shoppingCartItem.CmdyName
                                )), 1),
                                          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.unescapeHTML(
                                  shoppingCartItem.SubName ||
                                    shoppingCartItem.CmdySubName ||
                                    ''
                                )), 1)
                                        ], 8, _hoisted_28),
                                        _createElementVNode("div", _hoisted_31, [
                                          _createElementVNode("div", _hoisted_32, " NT. " + _toDisplayString(shoppingCartItem.TotalAmount?.toString() ||
                                (
                                  shoppingCartItem.MaxUnitFeeReal *
                                  shoppingCartItem.CmdyQty
                                ).toString()), 1)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_33, [
                                        _createVNode(_component_InputWithButton, {
                                          style: {"width":"120px"},
                                          maxNumber: 100,
                                          modelValue: shoppingCartItem.CmdyQty,
                                          "onUpdate:modelValue": ($event: any) => ((shoppingCartItem.CmdyQty) = $event),
                                          onAddClick: ($event: any) => (
                              _ctx.addClick(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'cmdy',
                                0
                              )
                            ),
                                          onSubtractClick: ($event: any) => (
                              _ctx.subtractClick(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'cmdy',
                                0
                              )
                            ),
                                          onBlur: ($event: any) => (
                              _ctx.itemUpdate(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'cmdy',
                                0
                              )
                            )
                                        }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                        _createElementVNode("div", _hoisted_34, [
                                          _createVNode(_component_FavoriteButton, {
                                            onClick: ($event: any) => (_ctx.addToCollect(shoppingCartItem)),
                                            isLike: shoppingCartItem.IsInCmdyCollect,
                                            width: '20px',
                                            iconType: 'circle'
                                          }, null, 8, ["onClick", "isLike"]),
                                          _createVNode(_component_Icon, {
                                            class: "cursor-pointer",
                                            onClick: ($event: any) => (
                                _ctx.cartStore.delShoppingCart(
                                  shoppingCartItem.OrderShoppingCartId,
                                  shoppingCartItemIndex,
                                  'cmdy',
                                  0
                                )
                              ),
                                            iconName: "circle_close",
                                            width: '20px'
                                          }, null, 8, ["onClick"])
                                        ])
                                      ]),
                                      (
                            shoppingCartItem.PackageCmdyList?.length !== 0 && shoppingCartItem.PackageCmdyList[0].UnitFeeReal !== 0
                          )
                                        ? (_openBlock(), _createBlock(_component_UnderLine, {
                                            key: 0,
                                            class: "w-auto ml-0"
                                          }))
                                        : _createCommentVNode("", true),
                                      (
                            shoppingCartItem.PackageCmdyList?.length !== 0 && shoppingCartItem.PackageCmdyList[0].UnitFeeReal !== 0
                          )
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                            _createElementVNode("div", _hoisted_36, [
                                              _createElementVNode("div", _hoisted_37, [
                                                _createElementVNode("div", _hoisted_38, [
                                                  _createElementVNode("div", _hoisted_39, [
                                                    _createVNode(_component_Icon, {
                                                      class: "mr-1.5",
                                                      iconName: "package",
                                                      width: '20px'
                                                    }),
                                                    _createElementVNode("span", _hoisted_40, " 禮品包裝 - " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].CmdyName || shoppingCartItem.PackageCmdyList[0].Name), 1)
                                                  ]),
                                                  _createElementVNode("div", _hoisted_41, [
                                                    _createElementVNode("div", _hoisted_42, [
                                                      _createElementVNode("div", _hoisted_43, " NT. " + _toDisplayString(shoppingCartItem.PackageCmdyList[0].UnitFeeReal), 1)
                                                    ])
                                                  ])
                                                ])
                                              ]),
                                              _createElementVNode("div", _hoisted_44, [
                                                _createVNode(_component_SquareItemFullImage, {
                                                  width: '60px',
                                                  class: "mr-[10px]"
                                                }),
                                                _hoisted_45
                                              ])
                                            ])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ])
                                  ])
                                ]),
                                (
                      shoppingCartItem.AddOnCmdyList !== undefined &&
                      shoppingCartItem.AddOnCmdyList.length !== 0
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.AddOnCmdyList, (addOnCmdyItem, addOnCmdyItemIndex) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: addOnCmdyItemIndex,
                                          class: "add-on-item flex"
                                        }, [
                                          _createElementVNode("div", _hoisted_47, [
                                            _createVNode(_component_SquareItemFullImage, {
                                              image: 
                            addOnCmdyItem.CmdyImage
                              ? addOnCmdyItem.CmdyImage.PcWeb
                              : addOnCmdyItem.Image.PcWeb
                          ,
                                              customClass: 'square-photo-content-no-cursor'
                                            }, null, 8, ["image"])
                                          ]),
                                          _createElementVNode("div", _hoisted_48, [
                                            _createElementVNode("div", _hoisted_49, [
                                              _createElementVNode("div", _hoisted_50, [
                                                _createElementVNode("div", _hoisted_51, [
                                                  _createVNode(_component_Icon, {
                                                    iconName: "add_on",
                                                    width: '20px'
                                                  })
                                                ]),
                                                _createElementVNode("span", _hoisted_52, " 加購商品 - " + _toDisplayString(addOnCmdyItem.CmdyName
                                  ? addOnCmdyItem.CmdyName
                                  : addOnCmdyItem.Name), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_53, [
                                                _createElementVNode("div", _hoisted_54, [
                                                  _createElementVNode("div", _hoisted_55, " NT. " + _toDisplayString(addOnCmdyItem.CmdyAmt
                                    ? addOnCmdyItem.CmdyAmt
                                    : addOnCmdyItem.UnitFeeReal *
                                      addOnCmdyItem.CmdyQty), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_56, [
                                              _createVNode(_component_InputWithButton, {
                                                style: {"width":"120px"},
                                                maxNumber: 100,
                                                modelValue: addOnCmdyItem.CmdyQty,
                                                "onUpdate:modelValue": ($event: any) => ((addOnCmdyItem.CmdyQty) = $event),
                                                onAddClick: ($event: any) => (
                              _ctx.addClick(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'addOn',
                                addOnCmdyItemIndex
                              )
                            ),
                                                onSubtractClick: ($event: any) => (
                              _ctx.subtractClick(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'addOn',
                                addOnCmdyItemIndex
                              )
                            ),
                                                onBlur: ($event: any) => (
                              _ctx.itemUpdate(
                                shoppingCartItem,
                                shoppingCartItemIndex,
                                'addOn',
                                addOnCmdyItemIndex
                              )
                            )
                                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onAddClick", "onSubtractClick", "onBlur"]),
                                              _createElementVNode("div", _hoisted_57, [
                                                _createVNode(_component_Icon, {
                                                  class: "cursor-pointer",
                                                  onClick: ($event: any) => (
                                _ctx.cartStore.delShoppingCart(
                                  addOnCmdyItem.OrderShoppingCartId,
                                  shoppingCartItemIndex,
                                  'addOn',
                                  addOnCmdyItemIndex
                                )
                              ),
                                                  iconName: "circle_close",
                                                  width: '20px'
                                                }, null, 8, ["onClick"])
                                              ])
                                            ])
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true),
                                (
                      shoppingCartItem.GiveawayCmdyList !== undefined &&
                      shoppingCartItem.GiveawayCmdyList.length !== 0
                    )
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shoppingCartItem.GiveawayCmdyList, (giveawayCmdyItem) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                          key: giveawayCmdyItem.CmdyId,
                                          class: "add-on-item flex"
                                        }, [
                                          _createElementVNode("div", _hoisted_59, [
                                            _createVNode(_component_SquareItemFullImage, {
                                              image: 
                            giveawayCmdyItem.CmdyImage
                              ? giveawayCmdyItem.CmdyImage.PcWeb
                              : giveawayCmdyItem.Image.PcWeb
                          ,
                                              customClass: 'square-photo-content-no-cursor'
                                            }, null, 8, ["image"])
                                          ]),
                                          _createElementVNode("div", _hoisted_60, [
                                            _createElementVNode("div", _hoisted_61, [
                                              _createElementVNode("div", _hoisted_62, [
                                                _createElementVNode("div", _hoisted_63, [
                                                  _createVNode(_component_Icon, {
                                                    iconName: 
                                  giveawayCmdyItem.CmdyQty == 0
                                    ? 'giveaway_gray'
                                    : 'giveaway_black'
                                ,
                                                    width: '20px'
                                                  }, null, 8, ["iconName"])
                                                ]),
                                                _createElementVNode("span", _hoisted_64, " 贈品 - " + _toDisplayString(giveawayCmdyItem.CmdyName), 1)
                                              ]),
                                              _createElementVNode("div", _hoisted_65, [
                                                _createElementVNode("div", _hoisted_66, [
                                                  _createElementVNode("div", _hoisted_67, " NT." + _toDisplayString(giveawayCmdyItem.UnitFeeReal), 1)
                                                ])
                                              ])
                                            ]),
                                            _createElementVNode("div", _hoisted_68, [
                                              _createElementVNode("div", _hoisted_69, _toDisplayString(giveawayCmdyItem.CmdyQty), 1)
                                            ]),
                                            _createElementVNode("div", {
                                              class: _normalizeClass([[
                            {
                              hidden: giveawayCmdyItem.IsOutOfStock === false
                            }
                          ], "flex items-center mb-1.5 font-medium text-xs text-dot-red"])
                                            }, " ・本贈品兌換數量已達上限，感謝您的支持。 ", 2)
                                          ])
                                        ]))
                                      }), 128))
                                    ]))
                                  : _createCommentVNode("", true)
                              ]))
                            }), 128))
                          ]),
                          _createVNode(_component_divider),
                          _createElementVNode("div", _hoisted_70, [
                            _createElementVNode("div", _hoisted_71, [
                              _createElementVNode("div", _hoisted_72, [
                                _hoisted_73,
                                _createElementVNode("span", null, _toDisplayString(_ctx.orderShoppingCartCmdyListRef.length), 1),
                                _hoisted_74
                              ]),
                              _createElementVNode("div", _hoisted_75, [
                                _hoisted_76,
                                _createElementVNode("span", _hoisted_77, [
                                  _hoisted_78,
                                  _createElementVNode("span", null, _toDisplayString(_ctx.cartStore.state.shoppingCartList.CartTotalAmount), 1)
                                ])
                              ])
                            ]),
                            _createVNode(_component_Btn, {
                              fontSize: '14px',
                              width: '157px',
                              height: '40px',
                              onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.goToPage('shoppingCart'))),
                              text: '結 帳'
                            })
                          ])
                        ]))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ], 32)
          ])
        ], 512))
      : _createCommentVNode("", true),
    _createVNode(_component_Menu, {
      menuList: _ctx.subMenuList,
      "onUpdate:menuList": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.subMenuList) = $event))
    }, null, 8, ["menuList"]),
    _createVNode(_component_ModalConfirm, { ref: "confirmModal" }, null, 512)
  ]))
}